import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Plan } from "../../../@types";
import {
  useTranslate,
  planDataUtils,
  isMedicareAdvantageType,
  isMapdPlanType,
} from "../../../helpers";
import { shouldSuppressPlanBenefits } from "../../../helpers/planHelpers";
import { $$ } from "../../../helpers/currencyUtilities";
import { AppContext } from "../../../app/store";
import { SubSectionTable } from "./helper";

export const Premiums: React.FunctionComponent<{ plan: Plan }> = ({ plan }) => {
  const t = useTranslate();
  const { state } = React.useContext(AppContext);
  const { mctCurrentPlanYear } = useFlags();
  const suppressed = shouldSuppressPlanBenefits(plan.redactions);

  const checkSuppressed = (value: unknown) => {
    return suppressed ? t("suppressed_plan_benefit") : value;
  };

  // porting the logic from "old" overview code
  const getPdpData = () => {
    return [
      {
        label: t("plan_details.overview.premiums.total_monthly_premium"),
        value: checkSuppressed($$(plan.calculated_monthly_premium)),
      },
    ];
  };

  const getMedicareAdvantageData = () => {
    const data = [
      {
        label: t("plan_details.overview.premiums.total_monthly_premium"),
        value: checkSuppressed($$(plan.calculated_monthly_premium)),
      },
      {
        label: t("plan_details.overview.premiums.health_premium"),
        value: checkSuppressed($$(plan.partc_premium)),
      },
    ];

    if (isMapdPlanType(plan.plan_type)) {
      data.push({
        label: t("plan_details.overview.premiums.drug_premium"),
        value: checkSuppressed(
          $$(
            planDataUtils.getPartDPremiumOrLIS(state, mctCurrentPlanYear, plan)
          )
        ),
      });
    }
    data.push(
      {
        label: t("plan_details.overview.premiums.standard_partb_premium"),
        value: checkSuppressed($$(planDataUtils.getPartBPremium(plan))),
      },
      {
        label: t("plan_details.overview.premiums.partb_premium_reduction"),
        value: checkSuppressed(
          plan.partb_premium_reduction > 0 ? t("yes") : t("no")
        ),
      }
    );
    return data;
  };

  const premiumsData = isMedicareAdvantageType(plan.plan_type)
    ? getMedicareAdvantageData()
    : getPdpData();

  return (
    <div>
      <SubSectionTable
        data={premiumsData}
        caption={t("plan_details.overview.premiums")}
      />
    </div>
  );
};
